import { onViewLoad } from "jose_modern/on_view_load.js";

function init() {
  // Shows the second stage of the cancel flow depending on which option the user selects
  document.querySelectorAll("input[name='reason']").forEach((el) => {
    el.addEventListener("change", (event) => {
      const selected = event.target.value;
      document.querySelector("#stage-1").classList.add("is-hidden");
      document.querySelector(`[data-reason='${selected}']`).classList.remove("is-hidden");
    });
  });

  // Syncs feature request input with form inputs
  document.querySelector("#feature_request").addEventListener("change", (event) => {
    document.querySelectorAll("input[name='cancellation_feedback']").forEach((el) => {
      el.value = event.target.value;
    });
  });

  // Syncs 'other' input with form inputs
  document.querySelector("#other_reason").addEventListener("change", (event) => {
    document.querySelectorAll("input[name='cancellation_feedback']").forEach((el) => {
      el.value = event.target.value;
    });
  });

  document.querySelectorAll("input[name='pause_duration']").forEach((el) => {
    el.addEventListener("change", (event) => {
      document.querySelector("input[name='duration']").value = event.target.value;
    });
  });
}

onViewLoad("subscriptions#cancel", init);
